<article class="selectable-row flex items-center border-2 rounded border-neutrals-grey-02 h-14 cursor-pointer" [class.selected-row]="isSelected()" [class.bg-neutrals-grey-01]="isOddRow()" (click)="showServiceInfoData.emit()">
    <div class="flex items-center h-full w-full min-w-0" [tooltip]="service()?.name!" [visibleTooltip]="serviceName" [position]="TooltipPosition.DYNAMIC">
        <app-service-tag class="ml-3.75 shrink-0" [serviceInfo]="service()!"></app-service-tag>
        <label #serviceName [id]="'service-'+service()?.id" class="ml-2.5 pr-2.5 min-w-0 font-normal text-base cursor-pointer truncate">{{ service()!.name }}</label>
    </div>

    <div class="shrink-0 w-px h-10.5 border-r border-neutrals-grey-02"></div>

    <a href="{{ getRouteUrl() }}" class="flex shrink-0 items-center w-15 h-13 justify-center cursor-pointer" (click)="$event.preventDefault(); $event.stopPropagation(); showRoutes.emit()" [tooltip]="literalService.get('services.tooltips.viewRoutes', true)" [position]="TooltipPosition.ABOVE">
        <img [src]="images.services.route" class="w-6 h-6" />
    </a>
</article>
